<template>
  <div class="row">
    <div class="border-bottom mb-3">
      <h5 class="text-muted fw-light">
        <i class="ri-user-follow-line"></i>
        Datos generales
      </h5>
    </div>
    <div class="form-group col-md-6 position-relative">
      <label>Cliente*</label>
      <multiselect
        v-model="cliente"
        :options="clientes"
        :value="[clientes]"
        :searchable="true"
        label="label"
        track-by="id"
        required
        placeholder="Seleccione"
        :object="true"
        :disabled="loadingClientes"
      ></multiselect>
      <div
        class="spinner-border text-primary spinner-border-sm position-absolute bottom-10 mb-1 end-4"
        role="status"
        v-if="loadingClientes"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="form-group col-md-3">
      <label>Fecha*</label
      ><input
        type="date"
        class="form-control"
        name="fecha"
        required=""
        autocomplete="off"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Importe*</label
      ><input
        type="tel"
        class="form-control"
        name="importe"
        required=""
        autocomplete="off"
        placeholder="00.00"
        @keydown="validateDecimal($event)"
      />
    </div>
  </div>
</template>

<script>
import useContratosStore from "@/store/contratos";
import Multiselect from "vue-multiselect";
import { useGeneralStore } from "@/store/general";
import { storeToRefs } from "pinia";

export default {
  components: {
    Multiselect,
  },
  setup() {
    const { validateDecimal } = useGeneralStore();
    const contratosStore = useContratosStore();

    const { fetchClientes } = contratosStore;

    const { loadingClientes, cliente, clientes } = storeToRefs(contratosStore);

    fetchClientes();

    return {
      clientes,
      loadingClientes,
      cliente,
      validateDecimal,
    };
  },
};
</script>

<style></style>
